const ROUTES = {
  "/": {
    "name": "HomePage27ebb7182df742baA2581b7815e0e4ef",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPages4d0bc7a0299047a8A2f34c341e885d57",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPage3538a127Aa334e0590c1D5d4f38c6467",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/leveling": {
    "name": "AboutLevelingPage5960a13aBea84838Af13Ca4ddfbdaeb6",
    "type": "HTML",
    "key": "about-leveling-page"
  },
  "/events/public": {
    "name": "PublicEventsPageC7b3a7b5B04f4457A2beCa2f064fa800",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPageCdf4c8390b3f4051A040Be65b6e59fa0",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/members/*": {
    "name": "MemberPagesA205bb2d69d341148f06D8094dda6655",
    "type": "HTML",
    "key": "member-pages"
  },
  "/members/messages/*": {
    "name": "MessagePages51196b2476d24b11Bfe5F3accc666a93",
    "type": "HTML",
    "key": "message-pages"
  },
  "/polytopia-2024": {
    "name": "Polytopia20242c6604e03fd44a62A69910a54631f001",
    "type": "HTML",
    "key": "polytopia-2024"
  },
  "/polytopia-2024/workshops": {
    "name": "Polytopia2024Workshops67429ef05c42457aA9aeD89ea03fd5ea",
    "type": "HTML",
    "key": "polytopia-2024-workshops"
  },
  "/polytopia-2025": {
    "name": "Polytopia2025106561f46b134d2e93b8980dbecda65c",
    "type": "HTML",
    "key": "polytopia-2025"
  },
  "/polytopia-2025/handouts": {
    "name": "Polytopia2025Handouts1018f660F5d1490eA4862d1112478006",
    "type": "HTML",
    "key": "polytopia-2025-handouts"
  },
  "/polytopia-2025/presenters": {
    "name": "Polytopia2025Presenters161ec63b1b36486eB50e3fce09959017",
    "type": "HTML",
    "key": "polytopia-2025-presenters"
  },
  "/polytopia-2025/schedule": {
    "name": "Polytopia2025Schedule96c941543a2347eeA6333f74c461ed62",
    "type": "HTML",
    "key": "polytopia-2025-schedule"
  },
  "/polytopia-2025/sponsors": {
    "name": "Polytopia2025Sponsors77f22cd6Ae6349b9Ae76F1f1c696d4b5",
    "type": "HTML",
    "key": "polytopia-2025-sponsors"
  },
  "/polytopia-2025/workshops": {
    "name": "Polytopia2025Workshops67f6f45b08834561B89e9c3cc608e0df",
    "type": "HTML",
    "key": "polytopia-2025-workshops"
  },
  "/polytopia-2026": {
    "name": "Polytopia2026Df06157b080e4a949534D6fd5e4e141c",
    "type": "HTML",
    "key": "polytopia-2026"
  },
  "/polytopia-2026/handouts": {
    "name": "Polytopia2026Handouts7d24c00a3e5145c385012d4fd3079d1f",
    "type": "HTML",
    "key": "polytopia-2026-handouts"
  },
  "/polytopia-2026/presenters": {
    "name": "Polytopia2026PresentersA4867a33B561450d85a936f67e3845ab",
    "type": "HTML",
    "key": "polytopia-2026-presenters"
  },
  "/polytopia-2026/schedule": {
    "name": "Polytopia2026ScheduleBf094e87989147189d43654487499262",
    "type": "HTML",
    "key": "polytopia-2026-schedule"
  },
  "/polytopia-2026/sponsors": {
    "name": "Polytopia2026Sponsors64a547e52697430589f9D0aef2a273c7",
    "type": "HTML",
    "key": "polytopia-2026-sponsors"
  },
  "/polytopia-2026/workshops": {
    "name": "Polytopia2026WorkshopsB93fa53c02354c33A2a74b3bfe6b8464",
    "type": "HTML",
    "key": "polytopia-2026-workshops"
  },
  "/resources": {
    "name": "ResourcesPage0ca15a34Ab6e4dc09e8d8d582e9365e6",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPages314318310fb14e5f880bB30691a5f62e",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;